import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const TestimonialsPage = () => {
  const testimonials = [
    {
      text: "Advance Elegance Studio captured our wedding perfectly. Every shot tells our story with such elegance and emotion. Their attention to detail and artistic vision made our special day even more memorable.",
      author: "Sarah & James Thompson",
      role: "Wedding Clients",
      image: "https://images.unsplash.com/photo-1532372320572-cda25653a26d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      rating: 5
    },
    {
      text: "Their commercial photography elevated our brand identity to new heights. Professional, creative, and truly exceptional work that has significantly impacted our market presence.",
      author: "Michael Chen",
      role: "Marketing Director, Luxury Brands Co.",
      image: "https://images.unsplash.com/photo-1574691250077-03a929faece5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      rating: 5
    },
    {
      text: "The attention to detail and artistic vision is unmatched. They transformed our property portfolio with stunning imagery that speaks to our luxury clientele.",
      author: "Emma Thompson",
      role: "Real Estate Developer",
      image: "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
      rating: 5
    }
  ];

  const brands = [
    "Luxury Hotels International",
    "Elite Fashion House",
    "Premium Real Estate Group",
    "Exclusive Events Co.",
    "Global Luxury Magazine",
    "High-End Jewelry Brand"
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-20"
    >
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1595777457583-95e059d581b8?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80')"
          }}
        >
          <div className="absolute inset-0 bg-black/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Client Stories</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Hear from our clients about their transformative fashion journey with us.
          </p>
        </div>
      </section>

      {/* Featured Testimonials */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="relative">
                <div className="absolute -top-4 -left-4">
                  <Quote className="h-8 w-8 text-emerald-400" />
                </div>
                <div className="p-8 bg-gray-900 rounded-lg">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 text-emerald-400 fill-current" />
                    ))}
                  </div>
                  <p className="text-gray-300 mb-6">{testimonial.text}</p>
                  <div className="flex items-center">
                    <div>
                      <p className="font-semibold">{testimonial.author}</p>
                      <p className="text-emerald-400 text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-full h-48 object-cover mt-6 rounded-lg"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section className="py-24 bg-black/95">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center mb-16">Trusted by Leading Brands</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="p-8 border border-gray-800 rounded-lg text-center hover:border-emerald-400 transition-colors"
              >
                <p className="text-xl font-semibold">{brand}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leave a Review */}
      <section className="py-24 bg-black">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Share Your Experience</h2>
          <p className="text-gray-400 mb-12">
            We value your feedback. Share your experience working with Advance Elegance Studio.
          </p>
          <form className="space-y-6">
            <div>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-6 py-3 bg-black border border-gray-800 rounded-lg focus:outline-none focus:border-emerald-400"
              />
            </div>
            <div>
              <textarea
                placeholder="Your Review"
                rows={4}
                className="w-full px-6 py-3 bg-black border border-gray-800 rounded-lg focus:outline-none focus:border-emerald-400"
              ></textarea>
            </div>
            <div className="flex justify-center">
              <button className="px-8 py-3 bg-emerald-400 text-black font-semibold rounded-full hover:bg-emerald-300 transition-colors">
                Submit Review
              </button>
            </div>
          </form>
        </div>
      </section>
    </motion.div>
  );
};

export default TestimonialsPage;